module.exports = __webpack_public_path__ + "img/douyin-code.3ff5c8ac.png";